module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"new_souvenir":"おみやげを手に入れました！"},"en":{"new_souvenir":"You Received a Souvenir!"}}')
  delete Component.options._Ctor
}
